import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/register.css';

const DRIVER_APP_URL =
  'https://expo.dev/accounts/shiftwagon7/projects/shift-wagon/builds/2dbc3acf-d4c5-45d7-b725-c166cb74d0c3';

const DriverProfileSetupPage: React.FC = () => {
  return (
    <section className="register-page">
      <div className="register-shell register-shell-single">
        <div className="register-panel register-panel-form">
          <div className="register-flow-panel register-flow-panel-success">
            <div className="register-status-badge">Driver Ready</div>
            <h1 className="register-form-title">Your driver onboarding has been submitted.</h1>
            <p className="register-form-copy">
              Your account, verification, documents, vehicle details, and final setup have all been
              completed on web. For now, profile maintenance stays in the driver app.
            </p>

            <div className="register-selected-town-card" style={{ width: '100%' }}>
              <div className="register-selected-town-header">
                <strong>What you can do next</strong>
              </div>
              <div className="register-selected-town-meta">1. Download the ShiftWagon driver app</div>
              <div className="register-selected-town-meta">2. Sign in and wait for review updates</div>
              <div className="register-selected-town-meta">3. Start receiving assignments once approved</div>
              <div className="register-selected-town-meta">4. Use the app for any profile maintenance later on</div>
            </div>

            <div className="register-flow-actions">
              <a
                className="register-submit register-submit-inline"
                href={DRIVER_APP_URL}
                rel="noreferrer"
                target="_blank"
              >
                Download Driver App APK
              </a>
              <Link className="register-secondary-button" to="/">
                Go home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DriverProfileSetupPage;
